import { getCookie } from "@insite/client-framework/Common/Cookies";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    CatalogPage,
    CatalogPageResult,
    GetCatalogPageByPathApiParameter,
} from "@insite/client-framework/Services/CategoryService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";

export interface GetCatalogPageByPathApiParameterStore extends GetCatalogPageByPathApiParameter {
    ymme?: string;
}

type Parameter = {
    path: string;
} & HasOnSuccess<CatalogPage>;
type Props = {
    apiParameter: GetCatalogPageByPathApiParameterStore;
    apiResult: CatalogPageResult;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterWithYmme: HandlerType = props => {
    // todo: this code is reused at three places; make a service with it
    const make = getCookie("ymmContextMakeKey") ? getCookie("ymmContextMakeKey") : "";
    const model = getCookie("ymmContextModelKey") ? getCookie("ymmContextModelKey") : "";
    const year = getCookie("ymmContextYearKey") ? getCookie("ymmContextYearKey") : "";
    const engine = getCookie("ymmContextEngineKey") ? getCookie("ymmContextEngineKey") : "";
    const vehicle = `${make}${model}${year}${engine}`; // todo: use redux state instead of cookie `const state = props.getState();`
    if (vehicle !== "") {
        props.apiParameter.ymme = vehicle;
    }
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterWithYmme);
